import { render, staticRenderFns } from "./DoucmentView.vue?vue&type=template&id=40b5dbc1"
import script from "./DoucmentView.vue?vue&type=script&lang=js"
export * from "./DoucmentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports